export default __webpack_public_path__ + "static/convenient-429a49f3707be6223cedaa03e5f63dba.svg";